import { CoreFormFieldSelect } from '@bambi/component-library/src/components/forms/fields/CoreFormFieldSelect';

import { FormFieldController } from 'src/common/FormField/FormFieldController';

export const SEAT_EQUIPMENT_CHOICES = [
  { label: 'No Equipment Required', value: '' },
  { label: 'Booster Seat', value: 'booster-seat' },
  { label: 'Car Seat', value: 'car-seat' },
];

export function SeatEquipmentSelect() {
  return (
    <FormFieldController name="seat_equipment">
      {({ field }) => {
        return (
          <CoreFormFieldSelect
            label="Seat Equipment"
            placeholder="No Equipment Required"
            inputProps={{ id: 'seat_equipment' }}
            options={SEAT_EQUIPMENT_CHOICES}
            onChange={(value) => {
              field.onChange(value.value);
            }}
            value={SEAT_EQUIPMENT_CHOICES.find((v) => v.value === field.value)}
          />
        );
      }}
    </FormFieldController>
  );
}
